module.exports = __webpack_public_path__ + "static/media/complete-Orange.442eb332.svg";